import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SvgComponent from '../../SvgComponent';
import { STATIC_ROOT } from '../../../constants';
import LoggedInComponent from './LoggedInComponent';
import headerService from '../../../services/header';
import LoggedOutComponent from './LoggedOutComponent';

import './MemberNavComponent.scss';

class MemberNavComponent extends React.Component {
    onClickBtMenuMobile(e) {
        e.preventDefault();
        this.props.dispatch(
            headerService.actions.toggleMenuMobileSlide(
                headerService.constants.MEMBRE_VERSION_MENU_MOBILE_SLIDE
            )
        );
    }

    render() {
        const { isAuthenticated } = this.props;
        return (
            <div className="menu-membre flex-container-h flex-center-alt">
                <div
                    className="menu-membre-ico curpt"
                    onClick={this.onClickBtMenuMobile.bind(this)}>
                    <SvgComponent src={`${STATIC_ROOT}/connexion.svg`} />
                </div>
                {isAuthenticated ? <LoggedInComponent /> : <LoggedOutComponent />}
            </div>
        );
    }
}

MemberNavComponent.propTypes = {
    user: PropTypes.object.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    stateOpenMenuMobileSlide: PropTypes.bool.isRequired,
    versionOpenMenuMobileSlide: PropTypes.string.isRequired,
    i18n: PropTypes.object.isRequired
};

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    return {
        i18n: state.i18n.feature.header.MEMBER_NAV
    };
}

export default connect(mapStateToProps)(MemberNavComponent);



// WEBPACK FOOTER //
// ./src/components/header/membernav/MemberNavComponent.js